<main>
  <loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>

  <header>
    <div class="headline flex gap-[2rem]">
      <h1>
        @if (isNew()) {
          {{ 'Client_PO_Create' | translateWF: 'New Client Purchase Order' }}
        } @else {
          {{ clientPurchaseOrder()?.number || ('Client_PO_Single' | translateWF: 'Client Purchase Order') }}
        }
      </h1>
      @if (!isNew() && clientPurchaseOrder()) {
        <csl-dropdown [formControl]="statusControl" [enumObject]="statusEnumObject()" [enumValueOptions]="clientPOStatusOptions()" />
      }
    </div>
    <div class="buttons">
      @if (canEdit()) {
        <p-splitbutton [label]="'Common_Save' | translateWF: 'Save'" [model]="saveMenuItems()" (onClick)="save(false)" [disabled]="itemsFormArray.length <= 0" />
      }
      <p-button [label]="'Cancel' | translateWF: 'Cancel'" variant="outlined" routerLink="/client-purchase-orders" />
    </div>
  </header>

  <div class="content">
    <div class="grid-12 gap-[1.5rem]">
      <div class="span-12-6">
        <div class="form-section">
          <h3>{{ 'Client_PO_General' | translateWF: 'General Details' }}</h3>

          <div class="form-box">
            <label>{{ 'Client_PO_Client' | translateWF: 'Client' }} *</label>
            <p-autoComplete
              fluid
              [formControl]="clientControl"
              [suggestions]="filteredClients()"
              field="name"
              (completeMethod)="searchBusiness($event, 'client')"
              (onSelect)="onSelectBusiness($event, 'client')"
              [forceSelection]="true"
              [dropdown]="true"
              [placeholder]="'Client_PO_SearchClient' | translateWF: 'Search client...'"
              class="w-full"
            ></p-autoComplete>
          </div>

          <div class="form-box">
            <label>{{ 'Client_PO_Brand' | translateWF: 'Brand' }}</label>
            <p-autoComplete
              fluid
              [formControl]="brandControl"
              [suggestions]="filteredBrands()"
              field="name"
              (completeMethod)="searchBusiness($event, 'brand')"
              (onSelect)="onSelectBusiness($event, 'brand')"
              [forceSelection]="true"
              [dropdown]="true"
              class="w-full"
            ></p-autoComplete>
          </div>

          <div class="form-box">
            <label>{{ 'Client_PO_ClientOrderNumber' | translateWF: 'Client Order Number' }} *</label>
            <input pInputText [formControl]="clientOrderNumberControl" class="w-full" />
          </div>

          <div class="form-box">
            <label>{{ 'Client_PO_DeliveryDate' | translateWF: 'Requested Delivery Date' }}</label>
            <p-datepicker [formControl]="requestedDeliveryDateControl" dateFormat="dd/mm/yy" class="w-full"></p-datepicker>
          </div>
        </div>
      </div>

      <div class="span-12-6">
        <div class="form-section">
          <h3>{{ 'Client_PO_Payment' | translateWF: 'Payment & Dates' }}</h3>

          <div class="form-box">
            <label>{{ 'Client_PO_PaymentTerms' | translateWF: 'Payment Terms' }} *</label>
            <csl-dropdown-master-data
              categoryCode="PaymentTermsClient"
              [formControl]="paymentTermCodeControl"
              [placeholder]="'Client_PO_SelectPaymentTerms' | translateWF: 'Select payment terms'"
            ></csl-dropdown-master-data>
          </div>

          <div class="form-box">
            <label>{{ 'Client_PO_ShippingTerm' | translateWF: 'Shipping Term' }}</label>
            <p-select
              [formControl]="shippingTermControl"
              [options]="shippingTermOptions()"
              optionLabel="label"
              optionValue="value"
              [placeholder]="'Select_Shipping_Terms' | translateWF: 'Select shipping terms'"
              appendTo="body"
              class="w-full"
            />
          </div>
        </div>
      </div>

      <div class="span-12-6">
        <div class="form-section">
          <h3>{{ 'Client_PO_ShipTo' | translateWF: 'Ship To' }}</h3>

          <div class="form-box">
            <label>{{ 'Client_PO_ShipToBusiness' | translateWF: 'Business' }} *</label>
            <p-autoComplete
              fluid
              [formControl]="shipToControl"
              [suggestions]="filteredShipTo()"
              field="name"
              (completeMethod)="searchBusiness($event, 'shipTo')"
              (onSelect)="onSelectBusiness($event, 'shipTo')"
              [forceSelection]="true"
              [dropdown]="true"
              [placeholder]="'Search_Business' | translateWF: 'Search Business'"
              class="w-full"
            ></p-autoComplete>
          </div>

          <div class="form-box">
            <label>{{ 'Client_PO_ShipToAddress' | translateWF: 'Address' }} *</label>
            <p-select
              [options]="shipToAddresses()"
              optionLabel="address1"
              optionValue="code"
              [formControl]="shipToAddressControl"
              [placeholder]="'Select_Address' | translateWF: 'Select Address'"
              appendTo="body"
              class="w-full"
            ></p-select>
          </div>
        </div>
      </div>

      <div class="span-12-6">
        <div class="form-section">
          <h3>{{ 'Client_PO_BillTo' | translateWF: 'Bill To' }}</h3>

          <div class="form-box">
            <label>{{ 'Client_PO_BillToBusiness' | translateWF: 'Business' }} *</label>
            <p-autoComplete
              fluid
              [formControl]="billToControl"
              [suggestions]="filteredBillTo()"
              field="name"
              (completeMethod)="searchBusiness($event, 'billTo')"
              (onSelect)="onSelectBusiness($event, 'billTo')"
              [forceSelection]="true"
              [dropdown]="true"
              [placeholder]="'Search_Business' | translateWF: 'Search Business'"
              class="w-full"
            ></p-autoComplete>
          </div>

          <div class="form-box">
            <label>{{ 'Client_PO_BillToAddress' | translateWF: 'Address' }} *</label>
            <p-select
              [options]="billToAddresses()"
              optionLabel="address1"
              optionValue="code"
              [formControl]="billToAddressControl"
              [placeholder]="'Select_Address' | translateWF: 'Select Address'"
              appendTo="body"
              class="w-full"
            ></p-select>
          </div>
        </div>
      </div>

      <div class="span-12">
        <div class="form-section">
          <h3>{{ 'Client_PO_Items' | translateWF: 'Items' }}</h3>

          @if (canEdit()) {
            <div class="row-sm-start-center mb-4">
              <span class="row-start-center gap-1 text-sm">
                <i class="pi pi-box text-blue-500"></i>
                {{ 'Client_PO_ItemMaster' | translateWF: 'Item Master' }}
              </span>
              <p-toggleSwitch [formControl]="searchByRecipeControl" />
              <span class="row-start-center gap-1 text-sm">
                <i class="pi pi-book text-green-500"></i>
                {{ 'Client_PO_Recipe' | translateWF: 'Recipe' }}
              </span>

              @if (!searchByRecipe()) {
                <p-autoComplete
                  [formControl]="itemSearchControl"
                  [suggestions]="itemOptions()"
                  optionLabel="itemCode"
                  (completeMethod)="searchItems($event)"
                  (onSelect)="onSelectItem($event)"
                  [forceSelection]="true"
                  [dropdown]="true"
                  dropdownIcon="pi pi-search"
                  appendTo="body"
                  [placeholder]="'Client_PO_SearchItems' | translateWF: 'Search items...'"
                >
                  <ng-template let-item pTemplate="item">
                    <span
                      ><strong>({{ item.itemCode }})</strong> {{ item.itemLongDisplayName | localized }}</span
                    >
                  </ng-template>
                </p-autoComplete>

                <p-button
                  label="{{ 'Common_Filters' | translateWF: 'Filters' }}"
                  variant="outlined"
                  severity="contrast"
                  icon="pi pi-plus"
                  [disabled]="filterMenuItems().length === 0"
                  (onClick)="itemFiltersMenu.toggle($event)"
                ></p-button>
                <p-menu #itemFiltersMenu [model]="filterMenuItems()" [popup]="true" appendTo="body"></p-menu>

                @if (activeFilters().includes('inventoryType')) {
                  <div class="row-start-center gap-1 ml-2 px-2 py-1 border rounded">
                    <p-select
                      [options]="inventoryTypeOptions()"
                      [formControl]="inventoryTypeFilterControl"
                      optionLabel="label"
                      optionValue="value"
                      [showClear]="true"
                      placeholder="{{ 'Client_PO_InventoryType' | translateWF: 'Inventory Type' }}"
                      appendTo="body"
                      class="min-w-[10rem]"
                    ></p-select>
                    <button
                      type="button"
                      class="text-gray-500 hover:text-red-600 px-1"
                      (click)="removeItemFilter('inventoryType')"
                      [pTooltip]="'Client_PO_RemoveFilter' | translateWF: 'Remove filter'"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-times text-xs"></i>
                    </button>
                  </div>
                }
              } @else {
                <p-autoComplete
                  [formControl]="recipeSearchControl"
                  [suggestions]="recipeSuggestions()"
                  optionLabel="name"
                  (completeMethod)="searchRecipes($event)"
                  (onSelect)="onSelectRecipe($event)"
                  [forceSelection]="true"
                  [dropdown]="true"
                  dropdownIcon="pi pi-search"
                  appendTo="body"
                  [placeholder]="'Client_PO_SearchRecipes' | translateWF: 'Search recipes...'"
                >
                  <ng-template let-recipe pTemplate="item">
                    <div class="col">
                      <span class="font-semibold">{{ recipe.number }}</span>
                      <span class="text-sm text-gray-600">{{ recipe.name }}</span>
                    </div>
                  </ng-template>
                </p-autoComplete>
              }
            </div>
          }

          <p-table [value]="itemsFormArray.controls" [rowHover]="showsAvailableInventory">
            <ng-template pTemplate="header">
              <tr>
                <th>{{ 'Client_PO_Code' | translateWF: 'Code' }}</th>
                <th>{{ 'Client_PO_Name' | translateWF: 'Name' }}</th>
                <th>{{ 'Client_PO_UOM' | translateWF: 'UOM' }}</th>
                <th>{{ 'Client_PO_Quantity' | translateWF: 'Quantity' }}</th>
                <th>{{ 'Client_PO_UnitPrice' | translateWF: 'Unit Price' }}</th>
                <th>{{ 'Client_PO_TaxRate' | translateWF: 'Tax Rate' }}</th>
                <th>{{ 'Client_PO_TotalPrice' | translateWF: 'Total Price' }}</th>
                @if (canEdit()) {
                  <th></th>
                }
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-fg let-index="rowIndex">
              <tr
                [class.p-datatable-selectable-row]="showsAvailableInventory"
                [class.p-datatable-row-selected]="showsAvailableInventory && fg === selectedLine()"
                (click)="showsAvailableInventory && selectedLine.set(fg)"
                (focusin)="showsAvailableInventory && selectedLine.set(fg)"
              >
                <td>
                  <div class="row-sm-start-center">
                    @if (fg.controls.productRecipeNumber.value) {
                      <i class="pi pi-book text-green-500" [pTooltip]="'Client_PO_Recipe' | translateWF: 'Recipe'"></i>
                    } @else {
                      <i class="pi pi-box text-blue-500" [pTooltip]="'Client_PO_ItemMaster' | translateWF: 'Item Master'"></i>
                    }
                    <span>{{ fg.controls.productRecipeNumber.value || fg.controls.itemCode.value }}</span>
                  </div>
                </td>
                <td>{{ fg.controls.name.value }}</td>
                <td>{{ unitOfMeasureEnums()[fg.controls.uom.value] }}</td>
                <td>
                  @if (canEdit()) {
                    <p-inputNumber [formControl]="fg.controls.quantity" [minFractionDigits]="2" mode="decimal" class="w-full"></p-inputNumber>
                  } @else {
                    {{ fg.controls.quantity.value }}
                  }
                </td>
                <td>
                  @if (canEdit()) {
                    <p-inputNumber [formControl]="fg.controls.unitPrice" [minFractionDigits]="2" mode="decimal" class="w-full"></p-inputNumber>
                  } @else {
                    {{ fg.controls.unitPrice.value | number: '1.2-2' }}
                  }
                </td>
                <td>
                  @if (canEdit()) {
                    <p-select [formControl]="fg.controls.taxRate" [options]="taxRateOptions" optionLabel="label" optionValue="value" appendTo="body" class="w-full" />
                  } @else {
                    {{ fg.controls.taxRate.value | percent: '1.0-2' }}
                  }
                </td>
                <td>{{ fg.controls.totalPrice.value | number: '1.2-2' }}</td>
                @if (canEdit()) {
                  <td>
                    <p-button severity="danger" icon="pi pi-trash" (focusin)="$event.stopPropagation()" (click)="$event.stopPropagation(); deleteItem(index)"></p-button>
                  </td>
                }
              </tr>
            </ng-template>
            <ng-template pTemplate="footer">
              <tr>
                <td colspan="6" class="text-right font-bold">{{ 'Client_PO_GrandTotal' | translateWF: 'Grand Total' }}</td>
                <td class="font-bold">{{ grandTotal() | number: '1.2-2' }}</td>
                @if (canEdit()) {
                  <td></td>
                }
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="canEdit() ? 8 : 7">
                  {{ 'Client_PO_No_Items' | translateWF: 'No items added yet' }}
                </td>
              </tr>
            </ng-template>
          </p-table>

          @if (showsAvailableInventory) {
            @if (selectedLine(); as line) {
              <app-client-po-available-inventory
                class="block mt-6"
                [itemCode]="line.controls.itemCode.value"
                [uomLabel]="selectedLineUomLabel()"
              ></app-client-po-available-inventory>
            } @else if (itemsFormArray.length > 0) {
              <p class="mt-4 text-sm text-gray-600">
                <i class="pi pi-info-circle mr-1"></i>
                {{ 'Client_PO_AvailableInventory_SelectLine' | translateWF: 'Select a line to see its available inventory' }}
              </p>
            }
          }
        </div>
      </div>
    </div>
  </div>
  <p-confirmDialog key="clientPOStatus" [closable]="false" />
</main>
